import { memo } from 'react';

import { ShareDesignColorRow } from '~/components/ShareModal/components/ShareDesignColorRow';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** "Header background" color swatch row, bound to the board design context. */
export const ShareBoardDesignHeaderBackgroundRow = memo(() => {
  const {
    brandColors,
    brandingDisabled,
    colorRoles,
    brandCustomizationEnabled,
    getColorRowProps,
    handleClearTransientColor,
    handleCommitColor,
    handleCommitBrandColor,
    handlePreviewChange,
    handleResetColor,
  } = useShareBoardDesign();

  const role = colorRoles.find((colorRole) => colorRole.readKey === 'headerBgColor');

  if (!role) {
    return null;
  }

  const { displayHex, isCustomColor, selectedBrandColorId } = getColorRowProps(role);

  return (
    <ShareDesignColorRow
      brandColors={brandColors}
      disabled={brandingDisabled}
      displayHex={displayHex}
      isCustomColor={isCustomColor}
      onDiscard={handleClearTransientColor}
      onPreviewChange={handlePreviewChange}
      onReset={handleResetColor}
      onSave={handleCommitColor}
      onSaveBrandColor={handleCommitBrandColor}
      role={role}
      selectedBrandColorId={selectedBrandColorId}
      // Upsell reflects only the plan gate, never the in-flight disabled state.
      showUpsell={!brandCustomizationEnabled}
    />
  );
});

ShareBoardDesignHeaderBackgroundRow.displayName = 'ShareBoardDesignHeaderBackgroundRow';
